import React from 'react';
//import { Button, Input } from 'antd';
import { getLoginDomain } from 'src/tools/getUserInfo';

const Login = (props) => {
  React.useEffect(() => {
    const d = getLoginDomain();
    window.location.href = `${d}/login`;
  }, []);
  //const a = '';
  return <div>Login</div>;
};
export default Login;
